import {
    Button,
    Command,
    CommandEmpty,
    CommandInput,
    CommandItem,
    CommandList,
    Popover,
    PopoverContent,
    PopoverTrigger,
} from '@repo/shadcn';
import { ChevronsUpDown } from 'lucide-react';
import * as React from 'react';

import { useAppSelector } from '../../../../features';
import { useGetCustomersQuery } from '../../../../features/slice/customers/customer-api-slice';

function useDebounce(value: string, delay: number) {
    const [debouncedValue, setDebouncedValue] = React.useState(value);

    React.useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
}
export function SaleCustomerAutoComplete({
    changeSelectedCustomer,
    singleCustomerDetails,
}: any) {
    const [open, setOpen] = React.useState(false);
    const [search, setSearchTerm] = React.useState('');

    const { selectedCustomer } = useAppSelector((state) => state.eventSlice);
    const { customerType } = useAppSelector((state) => state.eventSlice);

    const debounceSearch = useDebounce(search, 500);

    const { data: customerList, isLoading } = useGetCustomersQuery(
        {
            customer_type: customerType,
            search: debounceSearch,
            page: 1,
            limit: 10,
        },
        {
            skip: !debounceSearch && !customerType,
        },
    );

    const handleSearchInput = (value: string) => {
        setSearchTerm(value);
    };

    const renderCustomerList = () => {
        if (isLoading) {
            return <CommandItem>Loading...</CommandItem>;
        }

        if (!customerList || !customerList?.data) {
            return <CommandEmpty>Data not found</CommandEmpty>;
        }

        if (customerList?.data.length === 0) {
            return <CommandEmpty>No customer found</CommandEmpty>;
        }

        return (
            <div className="w-full">
                {customerList.data.map((item) => {
                    return (
                        <p
                            onClick={() => {
                                changeSelectedCustomer(item.id);
                                setOpen(false);
                            }}
                            className="cursor-pointer px-4 py-4 hover:bg-gray-100"
                        >
                            {item.name}
                        </p>
                    );
                })}
            </div>
        );
    };

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger
                asChild
                className=" max-w-[200px] border-none bg-transparent hover:bg-transparent"
            >
                <Button
                    variant="outline"
                    role="combobox"
                    aria-expanded={open}
                    className="!hover:bg-none  mt-2 w-full justify-end  bg-transparent pr-0 "
                >
                    {selectedCustomer
                        ? customerList?.data?.find(
                              (customer: any) =>
                                  customer.id === selectedCustomer,
                          )?.name
                        : singleCustomerDetails?.name
                          ? singleCustomerDetails?.name
                          : 'Select customer'}
                    <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-full p-0">
                <Command>
                    <CommandInput
                        onValueChange={handleSearchInput}
                        placeholder="Search customer..."
                    />
                    <CommandList>{renderCustomerList()}</CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    );
    // }
}
